import { request } from "../utils/request.js"

export const channel_addNew = (pojo, args) => request({
    url: 'channel/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const channel_update = (pojo, args) => request({
    url: 'channel/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const channel_findByPageForManage = (pojo, args) => request({
    url: 'channel/findByPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const channel_findListForManage = (pojo, args) => request({
    url: 'channel/findListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const channel_findByPageForSelect = (pojo, args) => request({
    url: 'channel/findByPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const channel_findListForSelect = (pojo, args) => request({
    url: 'channel/findListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const channel_changeFrozenStatus = (id, args) => request({
    url: 'channel/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const channel_deleteById = (id, args) => request({
    url: 'channel/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const channel_findById = (id, args) => request({
    url: 'channel/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/channel.js